import { useEffect } from "react";
import { RouterProvider } from "react-router/dom";
import { AppProviders } from "@/app/providers/AppProviders";
import { router } from "@/app/routes/router";
import { queryClient, trackPageEntries } from "@/lib/api/query-client";

export function App() {
  // Adresin yolu her değişince bir sayfa girişi: önceki cevaplar arka planda tazelenir (`query-client.ts`).
  useEffect(() => trackPageEntries(router, queryClient), []);

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
